import { NgModule } from '@angular/core';
import { SharedModule } from '@app/shared/shared.module';
import { ScreensaverComponent } from './screensaver.component';

@NgModule({
    declarations: [ScreensaverComponent],
    imports: [SharedModule],
    exports: [ScreensaverComponent]
})
export class ScreensaverUiModule {}
